import { useSuggestionSearchBarContext } from '@aibees/elephant/feature/suggestion-search-bar/context';
import { TableNoData } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { NoOptionProps as Props } from './types';

export const NoOption = memo(({ className }: Props) => {
  const { options, isOptionsLoading } = useSuggestionSearchBarContext();

  if (options.length || isOptionsLoading) return null;

  return (
    <Styled.Wrapper
      className={classnames('NoOption', className)}
      sx={SX.root}
      xs={12}
    >
      <TableNoData
        isError={false}
        config={{
          title: 'No Result Found',
          emptyIcon: 'search-1',
          emptyIconWrapperSX: SX.emptyIconWrapperSX,
        }}
      />
    </Styled.Wrapper>
  );
});

NoOption.displayName = 'NoOption';
